import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";

import { AuthProvider } from "utils/context/AuthContext";
import { ModalProvider } from "utils/context/ModalContext";
import MainContainer from "components/layout/MainContainer";
import GlobalModals from "components/GlobalModals";

import { routes } from "./utils/constants";
import { VariableProvider } from "utils/context/VariableContext";

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <AuthProvider>
        <VariableProvider>
            <ModalProvider>
                <RouterProvider router={router} />
                <GlobalModals />
            </ModalProvider>
        </VariableProvider>        
    </AuthProvider>
);

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     // <React.StrictMode>
//         <App />
//     // </React.StrictMode>
// )

// reportWebVitals();
